import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { LabelGrouping } from '@aibees/elephant/types/label';
import * as SX from './sx';

export const CONFIG: TableFilterSelectOption[] = [
  {
    key: LabelGrouping.COMPANY,
    value: LabelGrouping.COMPANY,
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: LabelGrouping.PEOPLE,
    value: LabelGrouping.PEOPLE,
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];
